import { JobDetailResponse } from '@doda/api-client/aspida/@types';
/**
 * スカウト求人詳細 PV計測時のlinkTrackVarsを取得する
 * @param {string | undefined} from 遷移区分
 * @returns {string} linkTrackVars
 */
export const getScoutLinkTrackVars = (from: string | undefined): string => {
  switch (from) {
    case 'scout_message':
      // 直接応募_スカウト（企業からのオファー）
      return 'Products,prop1,prop2,prop4,prop21,prop24,prop27,prop32,prop54,prop56,prop57,prop58,prop59,prop60,prop61,prop62,prop63,prop68,prop69,prop73,prop75,eVar1,eVar2,eVar4,eVar21,eVar24,eVar27,eVar54,eVar57,eVar61,eVar68,eVar70,eVar73,eVar74,eVar77,eVar78,eVar79,eVar82,eVar83,eVar85,eVar100,eVar116,eVar119,eVar123,eVar127,eVar171';
    case 'agent_message':
      // 紹介応募_プラス求人応募_スカウト（採用プロジェクト担当紹介求人）
      return 'Products,prop1,prop2,prop4,prop21,prop24,prop27,prop32,prop54,prop56,prop57,prop58,prop59,prop60,prop61,prop62,prop63,prop68,prop69,prop73,prop75,eVar1,eVar2,eVar4,eVar21,eVar24,eVar27,eVar54,eVar57,eVar61,eVar68,eVar70,eVar73,eVar74,eVar77,eVar78,eVar79,eVar82,eVar83,eVar85,eVar100,eVar116,eVar119,eVar123,eVar127,eVar171';
    default:
      return '';
  }
};

/**
 * 求人詳細 AA計測時のeventsを取得する
 * @param {boolean} isScout スカウト求人かどうか
 * @param {boolean} isRecommend レコメンド求人かどうか
 * @param {string} from 遷移区分
 * @param {boolean} isFavorited 気になる済みか
 * @param {boolean} isApproachingTheDeadline 締切間近か
 * @param {string} movieId 動画求人のID
 * @param {boolean} isRead 閲覧済みか
 * @returns {string} events
 */
export const getEvents = (
  isScout: boolean,
  isRecommend: boolean,
  from: string | undefined,
  isFavorited: boolean,
  isApproachingTheDeadline: boolean,
  movieId: string | undefined,
  isRead: boolean
): string => {
  const events = ['prodView'];
  if (!isScout) {
    // 掲載求人
    events.push('event196');
  }
  if (isScout) {
    if (from === 'scout_message') {
      // スカウト求人_課金
      events.push('event197');
    } else if (from === 'agent_message') {
      // スカウト求人_プラス
      events.push('event198');
    }
  }
  if (isRecommend) {
    // レコメンドからの遷移時
    events.push('event204');
  }
  if (isFavorited) {
    // 気になる済み
    events.push('event226');
  }
  if (isApproachingTheDeadline) {
    // 締切間近
    events.push('event228');
  }
  if (isRead) {
    // 閲覧済み
    events.push('event145');
  }

  if (movieId) {
    // 動画求人がある
    events.push('event97');
  }

  return events.join(',');
};

/**
 * 締切間近を判定し、取得する為の関数
 * @param jobSearchDetail
 */
export const getDeadlineApproachingStatus = (
  jobSearchDetail: JobDetailResponse | null
): boolean => {
  if (!jobSearchDetail) return false;
  return (
    jobSearchDetail?.job?.kodawariIconList
      ?.find((list) => list.key === '3501')
      ?.kodawariList?.find((kodawariList) => kodawariList.id === '23')?.name ===
    '締切間近'
  );
};
